import { render, staticRenderFns } from "./TheGame.vue?vue&type=template&id=3d14623b&scoped=true&"
import script from "./TheGame.vue?vue&type=script&lang=js&"
export * from "./TheGame.vue?vue&type=script&lang=js&"
import style0 from "./TheGame.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TheGame.vue?vue&type=style&index=1&id=3d14623b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d14623b",
  null
  
)

export default component.exports